import { Component, Input } from '@angular/core';
import { PopoverInput } from '../base/popover-input';

import { SupportDataService, SupplierService } from '../../../_services';
import { ISupplier } from '../../../_entities';

@Component({
    selector: 'popover-supplier-dropdown',
	template: require('./popover-supplier-dropdown.component.html')
})
export class PopoverSupplierDropdownComponent extends PopoverInput  {

	@Input() allowAdd: boolean = true;

	@Input() emptyText: string = "(Not set)";

	@Input() suppliers: ISupplier[] = null;

	@Input() allSuppliers: Promise<any>;

	addNewItem: ISupplier = <ISupplier>{id: 0, companyName: "Add new..."};
	newSupplier: string;

	validationMsg: string;

	constructor(private supplierService: SupplierService, supportData: SupportDataService) {
		super();

		//supplierService.getItems().then(result => this.suppliers = result);
	}

	ngOnInit() {
		//console.log("onInit ", this.allSuppliers);
		this.allSuppliers.then(result => this.suppliers = result);
	}

	async onPreSave($event) {

		this.validationMsg = "";

		//add new item before saving
		if (this.dirtyValue === 0 && !!this.newSupplier) {
			const supplier: ISupplier = {
				companyName: this.newSupplier
			};

			var createdSupplier = await this.supplierService.addItem(supplier);
			this.suppliers.push(<ISupplier>{ id: createdSupplier.id, companyName: createdSupplier.companyName });
			this.dirtyValue = createdSupplier.id;

			this.onSave($event);
			this.newSupplier = "";
		}
		else if (this.dirtyValue !== 0) {
			this.onSave($event);
		} else {
			$event.reject();
			this.validationMsg = "Please enter supplier name";
		}
		
	}

	get displayText() {
		
		if (this.suppliers) {
			const item = this.items.find(r => r.id === this.originalValue);

			if (item)
				return item.companyName;

			if (this.originalValue && item == null)
				return "!! " + this.dirtyValue;
		}


		return "";
	}

	get items(): ISupplier[] {
		//console.log("popopver items suppliers ", this.suppliers ? this.suppliers.length : "N/A");
		return this.suppliers;
	}

	get selectedItem() {

		if (this.items) {
			return this.items.concat([this.addNewItem]).find(r => r.id === this.dirtyValue);	
		}

		return null;
	}

	set selectedItem(val: ISupplier) { this.dirtyValue = val.id; }


}




// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./TypeScript/shared/editable-popover/specialized/popover-supplier-dropdown.component.ts